import html2canvas from '../../pckgs/h2c'

export async function getPreview({ html, css, cssUrl, width = 800, height = 600 }) {
    const iframe = document.createElement('iframe')
    iframe.style.position = 'absolute'
    iframe.style.top = '-9999px'
    if (width > 0) {
        iframe.style.width = width + 'px'
    }
    if (height > 0) {
        iframe.style.height = height + 'px'
    }
    document.body.appendChild(iframe)
    iframe.contentWindow.document.open()
    iframe.contentWindow.document.write(`<style>html,body{margin:0;padding:0}</style>`)
    if (cssUrl) {
        iframe.contentWindow.document.write(`<link rel="stylesheet" type="text/css" href="${cssUrl}"></link>`)
    }
    if (css) {
        iframe.contentWindow.document.write(`<style>${css}</style>`)
    }
    iframe.contentWindow.document.write(html)
    iframe.contentWindow.document.close()
    // html2canvas waits image loading automatically
    const canvas = await html2canvas(iframe.contentWindow.document.body, {
        width,
        height,
        allowTaint: false,
        logging: false,
        // if cors error use plugin or "disable cache" in devtools
        // https://chrome.google.com/webstore/detail/allow-cors-access-control/lhobafahddgcelffkeicbaginigeejlf
        useCORS: true,
        //ignoreElements: () => {
        // можно таким образом решить наличие мусора от редактора если по другому не полчится
        // <button type="button" class="ql-bold">
        // ...
        //}
    })
    document.body.removeChild(iframe)

    return canvas
}
